import { Controller } from "@hotwired/stimulus"

// Reusable swipeable gallery for slot reviews, casino reviews, game reviews, etc.
export default class extends Controller {
  static targets = ["scroll", "dot", "trackFill"]

  connect() {
    if (!this.hasScrollTarget) return
    this.scrollTarget.addEventListener("scroll", this.updateActiveDot.bind(this))
    this.dotTargets.forEach((dot, i) => {
      dot.addEventListener("click", () => this.goToSlide(i))
    })
    this.updateActiveDot()
  }

  updateActiveDot() {
    const el = this.scrollTarget
    const index = Math.round(el.scrollLeft / el.clientWidth)
    const slideCount = this.dotTargets.length

    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle("media-gallery__dot--active", i === index)
      dot.classList.toggle("media-gallery__dot--inactive", i !== index)
    })

    if (this.hasTrackFillTarget && slideCount > 0) {
      const widthPercent = 100 / slideCount
      this.trackFillTarget.style.width = `${widthPercent}%`
      this.trackFillTarget.style.transform = `translateX(${index * 100}%)`
    }
  }

  goToSlide(index) {
    const el = this.scrollTarget
    const slide = el.children[index]
    if (slide) el.scrollTo({ left: slide.offsetLeft, behavior: "smooth" })
  }
}
